import { render, staticRenderFns } from "./BrandingAboutModal.vue?vue&type=template&id=e6d8c1c2&scoped=true"
import script from "./BrandingAboutModal.vue?vue&type=script&lang=js"
export * from "./BrandingAboutModal.vue?vue&type=script&lang=js"
import style0 from "./BrandingAboutModal.vue?vue&type=style&index=0&id=e6d8c1c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d8c1c2",
  null
  
)

export default component.exports